import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CELL_SETS_REORDER } from 'redux/actionTypes/cellSets';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var reorderCellSetJsonMerger = function reorderCellSetJsonMerger(cellSetKey, newPosition, cellClassKey) {
  return [{
    $match: {
      query: "$[?(@.key == \"".concat(cellClassKey, "\")]"),
      value: {
        children: [{
          $match: {
            query: "$[?(@.key == \"".concat(cellSetKey, "\")]"),
            value: {
              $move: newPosition
            }
          }
        }]
      }
    }
  }];
};
var reorderCellClassJsonMerger = function reorderCellClassJsonMerger(cellClassKey, newPosition) {
  return [{
    $match: {
      query: "$[?(@.key == \"".concat(cellClassKey, "\")]"),
      value: {
        $move: newPosition
      }
    }
  }];
};
var reorderCellSet = function reorderCellSet(experimentId, cellSetKey, newPosition) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets$properti, parentNodeKey, rootNode, jsonMergerUpdateObject, payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets$properti = getCellSets()(getState().cellSets).properties[cellSetKey], parentNodeKey = _getCellSets$properti.parentNodeKey, rootNode = _getCellSets$properti.rootNode;
            jsonMergerUpdateObject = rootNode ? reorderCellClassJsonMerger(cellSetKey, newPosition) : reorderCellSetJsonMerger(cellSetKey, newPosition, parentNodeKey);
            _context.prev = 2;
            _context.next = 5;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets"), {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/boschni-json-merger+json'
              },
              body: JSON.stringify(jsonMergerUpdateObject)
            });
          case 5:
            payload = {
              cellSetKey: cellSetKey,
              newPosition: newPosition
            };
            if (!rootNode) {
              payload.cellClassKey = parentNodeKey;
            }
            _context.next = 9;
            return dispatch({
              type: CELL_SETS_REORDER,
              payload: payload
            });
          case 9:
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            handleError(_context.t0, endUserMessages.ERROR_SAVING);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default reorderCellSet;